export default {"src":"/_next/static/media/hamburgerMenu.b3e3e0e7.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};